export default {
    // getItem: state => (productId) => state.products.find((product) => product.id == productId),
    getCategory: state => (categoryId) => state.categories.find((category) => category.id == categoryId),
    getCategories: state => state.categories
  }